import { MaterialTransferido } from "@/shared/interfaces";
import { create } from "zustand";

interface InfoVerKitItemProps {
  open: boolean
  setOpen: (open: boolean) => void
  setProductos: (productos: MaterialTransferido[] | null) => void
  productos: MaterialTransferido[] | null
}

export const InfoVerKitItemStore = create<InfoVerKitItemProps>(set => ({
  open: false,
  setOpen(open) {
    set({ open })
  },
  productos: [],
  setProductos(productos) {
    set({ productos })
  },
}))